import React, { useMemo } from "react";
import { cn } from "../../lib/utils";
import moment from "moment";

type Props = {
  date: string;
  className?: string;
};

const EventDate = ({ date, className }: Props) => {
  const formattedDate = useMemo(() => {
    const weekdaysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthYear = moment(date).format("MMM, YYYY");
    const day = moment(date).format("D");
    const weekday = weekdaysShort[moment(date).format("e")];
    return { monthYear, day, weekday };
  }, [date]);

  return (
    <div className={cn("relative", className)}>
      <span className="flex items-center justify-center">
        <div className="flex flex-col items-center gap-2 pt-0 leading-none sm:gap-4">
          <span className="mt-1 text-base font-thin">
            {formattedDate.weekday}
          </span>
          <span className="text-h1 font-thin text-secondary">
            {formattedDate.day}
          </span>
          <span className="mb-1 text-xs font-thin">
            {formattedDate.monthYear}
          </span>
        </div>
      </span>
    </div>
  );
};

export default EventDate;
